module.exports = __webpack_public_path__ + "static/media/TPT_logo1.b24f4cef.png";